import { useEffect, useState } from 'react'

import { cn } from '@/lib/utils'

import { Ordem } from '../../entities/ordem'
import OrderItem from './OrderItem'

export default function Component({
  label,
  background,
  ordens,
}: {
  label: string
  background: string
  ordens: Ordem[]
}) {
  const visibleCount = 4
  const totalPages = Math.ceil(ordens.length / visibleCount)
  const [currentPage, setCurrentPage] = useState(0)

  useEffect(() => {
    if (ordens.length <= visibleCount) return
    const interval = setInterval(() => {
      setCurrentPage((prev) => (prev + 1) % totalPages)
    }, 30 * 1000)
    return () => clearInterval(interval)
  }, [ordens.length, totalPages])

  const visibleOrdens =
    ordens.length <= visibleCount
      ? ordens
      : ordens.slice(
          currentPage * visibleCount,
          currentPage * visibleCount + visibleCount,
        )

  return (
    <div className="flex flex-col gap-4 px-1">
      {/* HEADER */}
      <div className="pt-2">
        <div className={cn('rounded-full p-2', background)}>
          <h4 className="text-center text-lg font-bold">
            {label} ({ordens.length})
          </h4>
        </div>
      </div>

      {/* ORDERS */}
      <div className="flex flex-1 flex-col space-y-4">
        {visibleOrdens.map((ea) => (
          <OrderItem key={ea.id} ordem={ea} />
        ))}
      </div>

      {/* SCROLL INDICATOR */}
      <div className="flex justify-center gap-1 p-2">
        {Array.from({ length: totalPages }).map((_, index) => (
          <div
            key={index}
            className={cn(
              'size-3 rounded-full border border-muted-foreground',
              index === currentPage ? 'bg-zinc-600' : 'bg-zinc-200',
            )}
          ></div>
        ))}
      </div>
    </div>
  )
}
